import http from "@/settings/apiSettings"

class PORTAL_ProfilService {
  get(): Promise<any> {
    return http.clientPortalHR.get("/portal/profil", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  update(data: { Email?: string; Telefon?: string }): Promise<any> {
    return http.clientPortalHR.patch("/portal/profil", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  private auth() { return { headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") } }; }

  uploadPoza(base64: string): Promise<any> {
    return http.clientPortalHR.post("/portal/profil/poza", { Base64: base64 }, this.auth());
  }

  saveSemnatura(base64: string): Promise<any> {
    return http.clientPortalHR.post("/portal/profil/semnatura", { Base64: base64 }, this.auth());
  }

  solicitaModificare(data: any): Promise<any> {
    return http.clientPortalHR.post("/portal/profil/solicita-modificare", data, this.auth());
  }

  getPrioritati(): Promise<any> {
    return http.clientPortalHR.get("/portal/profil/prioritati", this.auth());
  }

  getBanci(): Promise<any> {
    return http.clientPortalHR.get("/portal/profil/banci", this.auth());
  }

  getTari(): Promise<any> {
    return http.clientPortalHR.get("/portal/profil/tari", this.auth());
  }

  getJudete(taraId: string): Promise<any> {
    return http.clientPortalHR.get("/portal/profil/judete", { ...this.auth(), params: { taraId } });
  }

  getLocalitati(judetId: string): Promise<any> {
    return http.clientPortalHR.get("/portal/profil/localitati", { ...this.auth(), params: { judetId } });
  }
}

export default new PORTAL_ProfilService();
